module.exports = __webpack_public_path__ + "static/media/cygate_logo.c26f0fc5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo/cygate_logo.svg
// module id = 263
// module chunks = 0